// Globalny stan aplikacji
import { configureStore } from '@reduxjs/toolkit';
import {
  authSlice,
  authSliceActions,
  cartSlice,
  cartSliceActions,
  productsSlice,
  productsSliceActions,
  uiSlice,
  uiSliceActions,
  cmsSlice,
  cmsSliceActions,
  traderDashboardSlice,
  traderDashboardSliceActions,
  traderPanelSlice,
  traderPanelSliceActions,
  chatSlice,
  chatSliceActions
} from './slices';

import { dynamicPageSlice, dynamicPageSliceActions } from 'plugins/store/slices';

import {
  TypedUseSelectorHook,
  useDispatch as useDispatchRedux,
  useSelector as useSelectorRedux
} from 'react-redux';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    cart: cartSlice,
    products: productsSlice,
    ui: uiSlice,
    cms: cmsSlice,
    traderDashboard: traderDashboardSlice,
    dynamicPage: dynamicPageSlice,
    traderPanel: traderPanelSlice,
    chat: chatSlice,
  }
});

export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useDispatch: () => AppDispatch = useDispatchRedux;
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;

export const reduxActions = {
  ...authSliceActions,
  ...cartSliceActions,
  ...productsSliceActions,
  ...uiSliceActions,
  ...cmsSliceActions,
  ...traderDashboardSliceActions,
  ...dynamicPageSliceActions,
  ...traderPanelSliceActions,
  ...chatSliceActions
};
